import * as ActionTypes from "constants/ActionTypes";

export const adminGetShopVirtualTryOns = (shopId, params = {}) => ({
  type: ActionTypes.ADMIN_GET_SHOP_VIRTUAL_TRYONS_START,
  shopId,
  params,
});

export const adminGetShopVirtualTryOnsSuccess = (data) => ({
  type: ActionTypes.ADMIN_GET_SHOP_VIRTUAL_TRYONS_SUCCESS,
  payload: data,
});

export const adminGetShopVirtualTryOnsFailure = (error) => ({
  type: ActionTypes.ADMIN_GET_SHOP_VIRTUAL_TRYONS_FAILURE,
  error,
});

export const adminResetShopVirtualTryOns = () => ({
  type: ActionTypes.ADMIN_RESET_SHOP_VIRTUAL_TRYONS,
});

